import axios from 'config/axios';

import { downloadFile, getFileName } from 'hh-shared/dist/utils/filesHelper';

const prefix = 'transportOrders';

export default class TransportOrdersSrv {
  static getForGrid(dataState) {
    return axios
      .post(`${prefix}/getForGrid`, dataState)
      .then(result => result.data);
  }

  static sendMessage(id, message) {
    return axios.post(`${prefix}/${id}/message`, { message });
  }

  static get(id) {
    return axios.get(`${prefix}/${id}`).then(result => result.data);
  }

  static getCars() {
    return axios.get(`${prefix}/getCars`).then(result => result.data);
  }

  static getDrivers() {
    return axios.get(`${prefix}/getDrivers`).then(result => result.data);
  }

  static getCarTypes() {
    return axios.get(`${prefix}/getCarTypes`).then(result => result.data);
  }

  static acceptForImplementation(model) {
    return axios
      .post(`${prefix}/acceptForImplementation`, model)
      .then(result => result.data);
  }

  static getCompletedTransportOrderPdf(id) {
    return axios
      .get(`${prefix}/getCompletedTransportOrderPdf/${id}`, {
        responseType: 'blob',
        timeout: 30000,
      })
      .then(result => result.data);
  }

  static delivered(model) {
    return axios.post(`${prefix}/delivered`, model).then(result => result.data);
  }

  static uploadAttachments(model) {
    return axios.post(`${prefix}/uploadAttachments`, model, {
      headers: { 'content-type': 'multipart/form-data' },
    });
  }

  static downloadAttachment(id) {
    return axios
      .get(`${prefix}/downloadAttachment/${id}`, { responseType: 'blob' })
      .then(response => {
        const type = response.headers['content-type'];
        const blob = new Blob([response.data], { type, encoding: 'UTF-8' });
        const fileName = getFileName(response);
        return downloadFile(blob, fileName);
      });
  }
}
